<script>
import StoreSearchResultsTabList from '@phoenix/mixins/components/store/StoreSearchResultsTabList';

export default {
  mixins: [StoreSearchResultsTabList],
};
</script>

<template>
  <ul class="list list--stacked list--lg">
    <li v-for="store in stores" :key="store.id">
      <store-card
        :key="store.id"
        :address="store.fullAddress"
        :image="store.rokkaImg"
        :title="store.name"
        :status="store.status"
        :phone="store.phone"
        :permalink="store.permalink"
        :product-categories="store.productCategories"
        :is-online="store.isOnline"
        :see-more-label="store.seeMoreLabel"
        :social-links="store.socialLinks"
        :is-reseller="store.isReseller"
        :phone-cta-tracking="store.phoneCtaTracking"
      />
    </li>
  </ul>
</template>
